"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
var date_fns_1 = require("date-fns");
exports.formatDate = function (value, dateFormat) {
    if (dateFormat === void 0) { dateFormat = 'MM/dd/yyyy'; }
    if (!value) {
        return '';
    }
    return date_fns_1.format(value, dateFormat);
};
